module.exports = __webpack_public_path__ + "img/3-1.0b9c9e5a.svg";